import React from 'react';
import classnames from 'classnames';
import AddRemoveFromList from 'Shared/AddRemoveFromList';
import LoginContainer from 'Shared/Login/Container';
import * as styles from './add-remove-from-list-or-login.scss';
const AddRemoveFromListOrLogin = ({ product, variantCode, className, hideFavoriteButton, hidePantriesButton, children }) => (React.createElement(LoginContainer, null, ({ isLoggedIn, setLoginUrl }) => (React.createElement("div", { className: classnames(styles.base, className), onClickCapture: e => {
        if (!isLoggedIn) {
            e.stopPropagation();
            setLoginUrl();
        }
    } },
    !hideFavoriteButton && React.createElement(AddRemoveFromList, { type: "favorites", code: variantCode, product: product, className: className }),
    !hidePantriesButton && React.createElement(AddRemoveFromList, { type: "pantries", code: variantCode, product: product, className: className }),
    !!children && children))));
export default AddRemoveFromListOrLogin;
